import { render, staticRenderFns } from "./AdminsList.vue?vue&type=template&id=11193b40&"
import script from "./admins-list.ts?vue&type=script&lang=ts&"
export * from "./admins-list.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports